import { useTransitionGoBack } from '@shared/lib/hooks';

/**
 * The issue reader's "back": a real history pop wrapped in a view transition,
 * so the cover-morph that brought the reader in plays in reverse on the way
 * out -- skipped when Back lands on a page reopening a `?dialog=` drawer. The
 * mechanism lives in `@shared/lib/hooks`' `useTransitionGoBack`, shared with
 * the reader-family preview's back button.
 *
 * Previously copy-pasted into four back buttons (the responsive topbar,
 * `IssueCover`, and both replica views) -- now each calls this.
 */
export function useReaderGoBack(): () => void {
	return useTransitionGoBack();
}
